import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-contents-field" }
const _hoisted_2 = {
  key: 0,
  class: "is-size-7 m-bottom-12 notify-user-warning"
}
const _hoisted_3 = {
  key: 1,
  class: "is-size-7 m-bottom-12"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "is-size-7 m-bottom-12 m-top-4" }, " Send an internal message to selected staff on the request. This message will not be visible to the requester. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormLabel = _resolveComponent("NrFormLabel")!
  const _component_nr_editor = _resolveComponent("nr-editor")!
  const _component_message_box = _resolveComponent("message-box")!

  return (_ctx.currentAction === 'comments')
    ? (_openBlock(), _createBlock(_component_message_box, {
        key: 0,
        title: "New internal message",
        type: "orange",
        "submit-text": "Send internal message",
        "disable-submit": $options.disableSubmit,
        onOnClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCurrentAction(''))),
        onOnCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCurrentAction(''))),
        onOnSubmit: $options.handleSubmitMessage
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_NrSelect, {
              modelValue: $data.selectedNotifiedUsers,
              placeholder: "Type or select a user to notify",
              options: $options.notifiableUsers,
              "onOption:selecting": $options.selectUsersToNotify,
              "onOption:deselecting": $options.deselectUsersToNotify,
              class: "m-top-12",
              filterable: true,
              multiple: "",
              required: ""
            }, {
              label: _withCtx(() => [
                _createTextVNode("Notify a user (required)")
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onOption:selecting", "onOption:deselecting"]),
            ($options.notifyUserWarning)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Select a user or group to notify. "))
              : (_openBlock(), _createElementBlock("p", _hoisted_3, " Only users assigned to this request can be notified. All internal messages still post to the timeline. ")),
            ($options.staffOnlyItems)
              ? (_openBlock(), _createBlock(_component_NrSelect, {
                  key: 2,
                  modelValue: $data.selectedMessageTemplates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.selectedMessageTemplates) = $event)),
                  placeholder: "Search and select message template(s)",
                  options: $options.filteredMessageTemplates,
                  filterable: false,
                  loading: _ctx.dataFetchState.message_templates.fetching,
                  hasMore: !_ctx.dataFetchState.message_templates.end,
                  "onOption:deselected": _cache[1] || (_cache[1] = ($event: any) => ($options.setMessageTemplate(true, $event))),
                  "onOption:selected": _cache[2] || (_cache[2] = ($event: any) => ($options.setMessageTemplate(false, $event))),
                  onOpen: $options.searchMessageTemplates,
                  onSearch: $options.searchMessageTemplates,
                  onLoadMore: $options.loadMoreMessageTemplates,
                  multiple: ""
                }, {
                  label: _withCtx(() => [
                    _createTextVNode("Message Template(s)")
                  ]),
                  _: 1
                }, 8, ["modelValue", "options", "loading", "hasMore", "onOpen", "onSearch", "onLoadMore"]))
              : _createCommentVNode("", true),
            _createVNode(_component_NrFormLabel, null, {
              default: _withCtx(() => [
                _createTextVNode("Message contents")
              ]),
              _: 1
            }),
            _createVNode(_component_nr_editor, {
              ref: "editor",
              modelValue: $data.message,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.message) = $event)),
              resizable: false,
              rows: 10,
              strike: "",
              link: "",
              bulletList: "",
              orderedList: ""
            }, null, 8, ["modelValue"]),
            _hoisted_4
          ])
        ]),
        _: 1
      }, 8, ["disable-submit", "onOnSubmit"]))
    : _createCommentVNode("", true)
}